"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _stores = require("@seedlang/stores");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ConjugationCardWrapper = function ConjugationCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "multipleChoiceSelected", _descriptor, _this);
      _initializerDefineProperty(_this, "correct", _descriptor2, _this);
      _initializerDefineProperty(_this, "randomTenseConceptId", _descriptor3, _this);
      _initializerDefineProperty(_this, "randomPronoun", _descriptor4, _this);
      _initializerDefineProperty(_this, "showAccentWarning", _descriptor5, _this);
      _initializerDefineProperty(_this, "showMultipleWordsWarning", _descriptor6, _this);
      _initializerDefineProperty(_this, "clickedAnswer", _descriptor7, _this);
      _initializerDefineProperty(_this, "buttonOptions", _descriptor8, _this);
      _this.getAvailableTenseIds = function () {
        var _this$props$card;
        if (!((_this$props$card = _this.props.card) !== null && _this$props$card !== void 0 && (_this$props$card = _this$props$card.word) !== null && _this$props$card !== void 0 && _this$props$card.conjugatedVerbStrings)) {
          return [];
        }
        var languageId = _this.props.card.word.languageId || _this.props.card.languageId || 'DE';
        var allTenseIds = Object.keys(_constants.Constants.GRAMMAR_TENSES[languageId]);
        return allTenseIds.filter(function (tenseId) {
          var conjugatedVerbString = _this.props.card.word.conjugatedVerbStrings.find(function (item) {
            return item.conceptId === tenseId;
          });
          return conjugatedVerbString === null || conjugatedVerbString === void 0 ? void 0 : conjugatedVerbString.hasAvailablePronouns;
        });
      };
      _this.getAvailablePronounsForTense = function (tenseConceptId) {
        var _this$props$card2;
        if (!((_this$props$card2 = _this.props.card) !== null && _this$props$card2 !== void 0 && (_this$props$card2 = _this$props$card2.word) !== null && _this$props$card2 !== void 0 && _this$props$card2.conjugatedVerbStrings)) {
          return [];
        }
        var conjugatedVerbString = _this.props.card.word.conjugatedVerbStrings.find(function (item) {
          return item.conceptId === tenseConceptId;
        });
        return (conjugatedVerbString === null || conjugatedVerbString === void 0 ? void 0 : conjugatedVerbString.availablePronouns) || [];
      };
      _this.loadConcept = function () {
        if ((0, _utils.isPresent)(_this.tenseConceptId) && (!_stores.ConceptStore.hasShowData || _stores.ConceptStore.showData.id !== _this.tenseConceptId)) {
          _stores.ConceptStore.getShow({
            ids: {
              conceptId: _this.tenseConceptId
            }
          });
        }
      };
      _this.conjugatedVerbStringDisplayValue = function (value) {
        if (value && _this.isReflexiveVerb) {
          var _this$props$card$word;
          return (0, _utils.displayTargetTextCorrectedForLanguage)(value.trim().replace(/^[^\s'’]+(?:['’]\s*|\s+)/, ''), (_this$props$card$word = _this.props.card.word) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word.languageId);
        } else if (value) {
          var _this$props$card$word2;
          return (0, _utils.displayTargetTextCorrectedForLanguage)(value.trim(), (_this$props$card$word2 = _this.props.card.word) === null || _this$props$card$word2 === void 0 ? void 0 : _this$props$card$word2.languageId);
        }
        return '';
      };
      _this.normalizeAndCompare = function (stringA, stringB) {
        return _state.DeckUI.normalizeString(stringA) === _state.DeckUI.normalizeString(stringB);
      };
      _this.onTextInputChange = function (val) {
        _state.DeckUI.onWordInputChange(_this.props.cardState, val);
        _this.showAccentWarning = false;
        if (_state.DeckUI.user.evaluateVocabOnKeystroke && _this.textInputIsCorrect) {
          _this.handleCorrectAnswer();
        } else if (_state.DeckUI.user.evaluateVocabOnKeystroke && _this.textInputIsCorrectWithoutAccent) {
          _this.showAccentWarning = true;
        } else if (_state.DeckUI.user.evaluateVocabOnKeystroke && !_this.textInputIsCorrectWithoutAccent) {
          _this.showAccentWarning = false;
        }
      };
      _this.evaluateTextInput = function () {
        if (_this.textInputIsCorrect) {
          _this.handleCorrectAnswer();
        } else if (_this.textInputIsCorrectWithoutAccent && !_this.showAccentWarning) {
          _this.showAccentWarning = true;
        } else if (_this.textInputIsMissingWords && !_this.showMultipleWordsWarning) {
          _this.showMultipleWordsWarning = true;
        } else {
          _this.handleIncorrectAnswer();
        }
      };
      _this.handleCorrectAnswer = function () {
        _this.correct = true;
        _this.props.userCard.set('score', 1);
        _state.DeckUI.onCorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
          xp: 1,
          xpSlug: 'conjugation'
        });
        setTimeout(function () {
          return _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
        }, 500);
      };
      _this.handleIncorrectAnswer = function () {
        _this.props.userCard.set('seen', true);
        _state.DeckUI.onIncorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard);
        setTimeout(function () {
          return _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
        }, 500);
      };
      _this.onClickButton = function (option) {
        _this.clickedAnswer = _this.conjugatedVerbStringDisplayValue(option.value);
        _this.props.cardState.selectedOptionText = _this.clickedAnswer;
        if (!_state.DeckUI.user.wasUiElementSeen('conjugation-multiple-choice')) {
          _state.DeckUI.designateUiElementAsSeen('conjugation-multiple-choice');
        }
        _this.multipleChoiceSelected = option.id;
        if (option.value === _this.correctAnswer) {
          _this.handleCorrectAnswer();
        } else {
          _this.handleIncorrectAnswer();
        }
        setTimeout(_this.clearSelection, 500);
      };
      _this.clearSelection = function () {
        _this.multipleChoiceSelected = null;
      };
      var availableTenseIds = _this.getAvailableTenseIds();
      var defaultPronouns = ['singular_1p', 'singular_2p', 'singular_3p', 'plural_1p', 'plural_2p', 'plural_3p'];
      if (availableTenseIds.length > 0) {
        _this.randomTenseConceptId = (0, _lodash.shuffle)(availableTenseIds)[0];
        var availablePronouns = _this.getAvailablePronounsForTense(_this.randomTenseConceptId);
        _this.randomPronoun = (0, _lodash.shuffle)(availablePronouns.length > 0 ? availablePronouns : defaultPronouns)[0];
      } else {
        _this.randomTenseConceptId = (0, _lodash.shuffle)(Object.keys(_constants.Constants.GRAMMAR_TENSES[_this.props.card.word.languageId || _this.props.card.languageId || 'DE']))[0];
        _this.randomPronoun = (0, _lodash.shuffle)(defaultPronouns)[0];
      }
      if (!(0, _utils.isPresent)(_this.props.card.pronoun)) {
        _this.props.card.pronoun = _this.randomPronoun;
      }
      if (!(0, _utils.isPresent)(_this.props.card.tenseConceptId)) {
        _this.props.card.tenseConceptId = _this.randomTenseConceptId;
      }
      _this.refreshButtonOptions();
      _this.loadConcept();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.buttonOptionsKey !== this.lastButtonOptionsKey) {
          this.refreshButtonOptions();
        }
      }
    }, {
      key: "revealed",
      get: function get() {
        return this.props.cardState.revealed;
      }
    }, {
      key: "tenseConceptId",
      get: function get() {
        return (0, _utils.isPresent)(this.props.card.tenseConceptId) ? this.props.card.tenseConceptId : this.randomTenseConceptId; // german present tenses
      }
    }, {
      key: "pronoun",
      get: function get() {
        return (0, _utils.isPresent)(this.props.card.pronoun) ? this.props.card.pronoun : this.randomPronoun;
      }
    }, {
      key: "pronounField",
      get: function get() {
        return this.pronoun.replace('_', '');
      }
    }, {
      key: "isPastPerfect",
      get: function get() {
        return this.props.card.word.languageId === 'DE' && this.tenseConceptId === 'c1e9f360-b6d3-422b-bde4-1ad86deb466a' || this.props.card.word.languageId === 'FR' && this.tenseConceptId === '1dc1f99d-c766-4c2c-9f8e-0219c6b28b21';
      }
    }, {
      key: "buttonOptionsKey",
      get: function get() {
        var _this$props$card$word3, _this$props$card$sent;
        return [this.props.card.id, this.tenseConceptId, this.pronoun, this.correctAnswer, this.correctAnswerFromConjugatedVerbString, this.isPastPerfect, (_this$props$card$word3 = this.props.card.word) === null || _this$props$card$word3 === void 0 ? void 0 : _this$props$card$word3.id, (_this$props$card$sent = this.props.card.sentence) === null || _this$props$card$sent === void 0 ? void 0 : _this$props$card$sent.targetText].join('|');
      }
    }, {
      key: "buildButtonOptions",
      value: function buildButtonOptions() {
        var _this$props$card3,
          _built,
          _this2 = this;
        var built;
        if (this.isPastPerfect && (this.props.card.word.languageId === 'DE' || ((_this$props$card3 = this.props.card) === null || _this$props$card3 === void 0 || (_this$props$card3 = _this$props$card3.word) === null || _this$props$card3 === void 0 || (_this$props$card3 = _this$props$card3.level) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.position) > 1)) {
          built = this.pastPerfectOptions;
        }
        if (!((_built = built) !== null && _built !== void 0 && _built.length)) {
          var _options, _DeckUI$targetLanguag;
          var options = [];
          (_options = options).push.apply(_options, _toConsumableArray(this.randomOptionsFromTense));
          if (((_DeckUI$targetLanguag = _state.DeckUI.targetLanguage.level) === null || _DeckUI$targetLanguag === void 0 ? void 0 : _DeckUI$targetLanguag.position) > 1 || options.length < 3) {
            var _options2;
            (_options2 = options).push.apply(_options2, _toConsumableArray(this.randomOptionsFromPronoun));
          }
          options = (0, _lodash.shuffle)((0, _lodash.uniq)(options.filter(function (item) {
            return _this2.conjugatedVerbStringDisplayValue(item) !== _this2.conjugatedVerbStringDisplayValue(_this2.correctAnswer) && _this2.conjugatedVerbStringDisplayValue(item) !== _this2.conjugatedVerbStringDisplayValue(_this2.correctAnswerFromConjugatedVerbString);
          })));
          if (options.length >= 3) {
            options = options.slice(0, 3);
          } else {
            options = options.slice(0, 1);
          }
          options.push(this.correctAnswer);
          built = (0, _lodash.shuffle)(options).map(function (item, index) {
            return {
              id: index,
              value: item,
              displayValue: _this2.conjugatedVerbStringDisplayValue(item)
            };
          });
        }
        return built.map(function (o) {
          return _objectSpread(_objectSpread({}, o), {}, {
            text: o.displayValue,
            correct: o.value === _this2.correctAnswer
          });
        });
      }
    }, {
      key: "refreshButtonOptions",
      value: function refreshButtonOptions() {
        var built = this.buildButtonOptions();
        this.buttonOptions = built;
        this.lastButtonOptionsKey = this.buttonOptionsKey;
        this.props.card.set('multipleChoiceOptions', built);
      }
    }, {
      key: "pastPerfectOptions",
      get: function get() {
        var _this3 = this;
        if (!this.correctAnswer) {
          return [];
        }
        if (!(this.props.card.word.languageId === 'DE' && this.tenseConceptId === 'c1e9f360-b6d3-422b-bde4-1ad86deb466a') && !(this.props.card.word.languageId === 'FR' && this.tenseConceptId === '1dc1f99d-c766-4c2c-9f8e-0219c6b28b21')) {
          return [];
        }
        if (this.props.card.word.languageId === 'DE') {
          var otherVerb,
            middle = '';
          var auxOptions = {
            singular_1p: ['bin', 'habe'],
            singular_2p: ['bist', 'hast'],
            singular_3p: ['ist', 'hat'],
            plural_1p: ['sind', 'haben'],
            plural_2p: ['seid', 'habt'],
            plural_3p: ['sind', 'haben']
          };
          var aux = this.correctAnswer.split(' ')[0];
          var verb = (0, _lodash.last)(this.correctAnswer.split(' '));
          if (verb.slice(-2) === 'ten') {
            otherVerb = verb.slice(0, verb.length - 2);
          } else if (otherVerb = verb.slice(-2) === 'et') {
            otherVerb = "".concat(verb.slice(0, verb.length - 1), "n");
          } else if (otherVerb = verb.slice(-1) === 't') {
            otherVerb = "".concat(verb.slice(0, verb.length - 1), "en");
          } else {
            otherVerb = "".concat(verb.slice(0, verb.length - 2), "t");
          }
          if (this.correctAnswer.split(' ').length > 2) {
            middle = "".concat(this.correctAnswer.split(' ')[1], " ");
          }
          var otherAux = aux.slice(0, 1) === 'h' ? auxOptions[this.pronoun][0] : auxOptions[this.pronoun][1];
          var options = ["".concat(aux, " ").concat(middle).concat(verb), "".concat(otherAux, " ").concat(middle).concat(verb), "".concat(aux, " ").concat(middle).concat(otherVerb), "".concat(otherAux, " ").concat(middle).concat(otherVerb)];
          return options.sort().map(function (item, index) {
            return {
              id: index,
              displayValue: item,
              value: item
            };
          });
        }
        if (this.props.card.word.languageId === 'FR') {
          var parts = this.correctAnswer.trim().match(/^((?:(?:me|te|se|nous|vous|le|la|les|lui|leur|y|en)\s+|[mtsl]['’]\s*)*)(ai|as|a|avons|avez|ont|suis|es|est|sommes|êtes|sont)(\s+.+)$/i);
          if (!parts) {
            return [];
          }
          var _parts = _slicedToArray(parts, 4),
            beginning = _parts[1],
            _aux = _parts[2],
            remainder = _parts[3];
          var _auxOptions = {
            singular_1p: ['ai', 'suis'],
            singular_2p: ['as', 'es'],
            singular_3p: ['a', 'est'],
            plural_1p: ['avons', 'sommes'],
            plural_2p: ['avez', 'êtes'],
            plural_3p: ['ont', 'sont']
          };
          var _otherAux = ['ai', 'as', 'a', 'avons', 'avez', 'ont'].includes(_aux.toLowerCase()) ? _auxOptions[this.pronoun][1] : _auxOptions[this.pronoun][0];
          var _options3 = [this.correctAnswer, "".concat(beginning).concat(_otherAux).concat(remainder)];
          var displayKey = function displayKey(value) {
            return _this3.conjugatedVerbStringDisplayValue(value).replace(/’/g, "'").toLowerCase();
          };
          var excluded = new Set([].concat(_options3, _toConsumableArray(this.correctAnswers), [this.correctAnswerFromConjugatedVerbString]).filter(_utils.isPresent).map(displayKey));
          var _iterator = _createForOfIteratorHelper((0, _lodash.shuffle)(this.randomOptionsFromTense || [])),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var candidate = _step.value;
              var key = displayKey(candidate);
              if (!excluded.has(key)) {
                _options3.push(candidate);
                excluded.add(key);
              }
              if (_options3.length === 4) {
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return (0, _lodash.shuffle)(_options3).map(function (item, index) {
            return {
              id: index,
              value: item,
              displayValue: _this3.conjugatedVerbStringDisplayValue(item.replace(/^(me|te|se) ([aoe])/, function (_, pronoun, vowel) {
                return "".concat(pronoun[0], "'").concat(vowel);
              }))
            };
          });
        }
      }
    }, {
      key: "icons",
      get: function get() {
        var _this$props$card$conc, _this$props$card$conc2;
        if (this.showWordCard) {
          return [];
        }
        var ary = [];
        if (!this.props.cardState.revealed && this.props.card.cardType.slug !== 'conjugation-fill-in-blanks' && this.props.card.cardType.slug !== 'conjugation-multiple-choice') {
          ary.push('toggleMultipleChoice');
        }
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed && (0, _utils.isPresent)(this.props.card.tenseConceptId) && ((_this$props$card$conc = this.props.card.concept) !== null && _this$props$card$conc !== void 0 && _this$props$card$conc.longDescription || (_this$props$card$conc2 = this.props.card.concept) !== null && _this$props$card$conc2 !== void 0 && _this$props$card$conc2.longDescriptionMd)) {
          ary.push('tenseDescription');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        return ary;
      }
    }, {
      key: "randomOptionsFromPronoun",
      get: function get() {
        var _this$props$card4,
          _this4 = this;
        if (!((_this$props$card4 = this.props.card) !== null && _this$props$card4 !== void 0 && (_this$props$card4 = _this$props$card4.word) !== null && _this$props$card4 !== void 0 && _this$props$card4.conjugatedVerbStrings)) {
          return;
        }
        var hideField = "hide".concat(this.pronounField.charAt(0).toUpperCase()).concat(this.pronounField.slice(1));
        var options = this.props.card.word.conjugatedVerbStrings.filter(function (item) {
          return !item[hideField] && (0, _utils.isPresent)(item[_this4.pronounField]);
        }).map(function (item) {
          return item[_this4.pronounField];
        });
        var displayOptions = options.map(function (item) {
          return _this4.conjugatedVerbStringDisplayValue(item);
        });
        options = options.filter(function (item, index) {
          return displayOptions.indexOf(_this4.conjugatedVerbStringDisplayValue(item)) === index;
        });
        return options;
      }
    }, {
      key: "randomOptionsFromTense",
      get: function get() {
        var _this$props$card5,
          _this5 = this;
        if (!((_this$props$card5 = this.props.card) !== null && _this$props$card5 !== void 0 && (_this$props$card5 = _this$props$card5.word) !== null && _this$props$card5 !== void 0 && _this$props$card5.conjugatedVerbStrings)) {
          return;
        }
        var conjugatedVerbString = this.props.card.word.conjugatedVerbStrings.find(function (item) {
          return item.conceptId === _this5.tenseConceptId;
        });
        if (conjugatedVerbString) {
          var pronounFields = ['singular1p', 'singular2p', 'singular3p', 'plural1p', 'plural2p', 'plural3p'];
          var options = pronounFields.filter(function (field) {
            return !conjugatedVerbString["hide".concat(field.charAt(0).toUpperCase()).concat(field.slice(1))] && (0, _utils.isPresent)(conjugatedVerbString[field]);
          }).map(function (field) {
            return conjugatedVerbString[field];
          });
          var displayOptions = options.map(function (item) {
            return _this5.conjugatedVerbStringDisplayValue(item);
          });
          options = options.filter(function (item, index) {
            return displayOptions.indexOf(_this5.conjugatedVerbStringDisplayValue(item)) === index;
          });
          return options;
        }
      }
    }, {
      key: "correctConjugatedVerbString",
      get: function get() {
        var _this6 = this;
        return this.props.card.word.conjugatedVerbStrings.find(function (item) {
          return item.conceptId === _this6.tenseConceptId;
        });
      }
    }, {
      key: "correctAnswer",
      get: function get() {
        var _this$props$card$sent2;
        if ((0, _utils.isPresent)((_this$props$card$sent2 = this.props.card.sentence) === null || _this$props$card$sent2 === void 0 ? void 0 : _this$props$card$sent2.targetText)) {
          return this.props.card.sentence.targetText.trim().replace(/(\.\.\.|…)/, '').split(' ').slice(1).join(' ');
        }
        return this.correctAnswerFromConjugatedVerbString;
      }
    }, {
      key: "correctAnswerFromConjugatedVerbString",
      get: function get() {
        if (this.correctConjugatedVerbString) {
          return this.correctConjugatedVerbString[this.pronoun.replace('_', '')].replace(/'/, '\' ').replace(/\s+/, ' ');
        }
      }
    }, {
      key: "correctAnswers",
      get: function get() {
        if (this.isPastPerfect && this.props.card.word.languageId === 'FR') {
          return (0, _lodash.flatten)([this.correctAnswer, this.frenchPerfectCorrectAnswers]);
        }
        return [this.correctAnswer];
      }
    }, {
      key: "frenchPerfectCorrectAnswers",
      get: function get() {
        var correctAnswers = [];
        if (/\b(me|te)*\s*(suis|es)\b/.test(this.correctAnswer)) {
          if (this.correctAnswer.endsWith('e')) {
            correctAnswers.push(this.correctAnswer.replace(/e$/, ''));
          } else {
            correctAnswers.push("".concat(this.correctAnswer, "e"));
          }
        }
        if (/\b(nous|vous)*\s*(sommes|êtes)\b/.test(this.correctAnswer)) {
          if (this.correctAnswer.endsWith('es')) {
            correctAnswers.push(this.correctAnswer.replace(/es$/, 's'));
          } else {
            correctAnswers.push(this.correctAnswer.replace(/s$/, 'es'));
          }
        }
        return correctAnswers;
      }
    }, {
      key: "textInputWithoutPronoun",
      get: function get() {
        var _this$props$card6, _pronounPattern;
        // users sometimes erroneously add the pronoun in the text input
        var textInput = this.props.cardState.textEntry;
        var pronounString = _constants.Constants.PRONOUN_STRINGS[((_this$props$card6 = this.props.card) === null || _this$props$card6 === void 0 || (_this$props$card6 = _this$props$card6.word) === null || _this$props$card6 === void 0 ? void 0 : _this$props$card6.languageId) || 'DE'][this.pronoun].split(',')[0];
        var parenthesesPattern = new RegExp('\s\(.+\)');
        var pronounPattern;
        if (parenthesesPattern.test(pronounString)) {
          pronounPattern = new RegExp("^(".concat(pronounString, "|").concat(pronounString.replace(parenthesesPattern, ''), ")\\s"));
        } else {
          pronounPattern = new RegExp("^".concat(pronounString, "\\s"));
        }
        if ((_pronounPattern = pronounPattern) !== null && _pronounPattern !== void 0 && _pronounPattern.test(textInput)) {
          textInput = textInput.replace(pronounPattern, '');
        }
        return textInput;
      }
    }, {
      key: "textInputIsCorrect",
      get: function get() {
        var _this7 = this;
        var textInputVersions = (0, _lodash.uniq)([this.props.cardState.textEntry, this.textInputWithoutPronoun]);
        return (0, _lodash.some)((0, _lodash.flatten)(textInputVersions.map(function (textInput) {
          return (0, _lodash.flatten)(_this7.correctAnswers.map(function (correctAnswer) {
            return _this7.normalizeAndCompare(textInput, correctAnswer.toLowerCase());
          }));
        })));
      }
    }, {
      key: "textInputIsCorrectWithoutAccent",
      get: function get() {
        return !this.textInputIsCorrect && (0, _lodash.deburr)(_state.DeckUI.normalizeString(this.props.cardState.textEntry)) === (0, _lodash.deburr)(_state.DeckUI.normalizeString(this.correctAnswer.toLowerCase()));
      }
    }, {
      key: "textInputIsMissingWords",
      get: function get() {
        return this.correctAnswer && this.correctAnswer.match(' ') && (0, _utils.isPresent)(this.props.cardState.textEntry) && this.props.cardState.textEntry.split(/(\s+|'|’)/).length < this.correctAnswer.toString().split(/\s+/).length;
      }
    }, {
      key: "isReflexiveVerb",
      get: function get() {
        return this.props.card.word.languageId === 'FR' && /^s[e']\b/.test(this.props.card.word.targetText) || this.props.card.word.languageId === 'ES' && this.props.card.word.targetText.endsWith('se');
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          buttonOptions: this.buttonOptions,
          correctAnswer: this.correctAnswer,
          onClickButton: this.onClickButton,
          multipleChoiceSelected: this.multipleChoiceSelected,
          revealed: this.revealed,
          correct: this.correct,
          onTextInputChange: this.onTextInputChange,
          evaluateTextInput: this.evaluateTextInput,
          showAccentWarning: this.showAccentWarning,
          icons: this.icons,
          showMultipleWordsWarning: this.showMultipleWordsWarning,
          pronoun: this.pronoun,
          tenseConceptId: this.tenseConceptId,
          clickedAnswer: this.clickedAnswer,
          isReflexiveVerb: this.isReflexiveVerb,
          showTextEntryCard: this.showTextEntryCard
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceSelected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "correct", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "randomTenseConceptId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "randomPronoun", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "showAccentWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showMultipleWordsWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "clickedAnswer", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "buttonOptions", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "revealed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "revealed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tenseConceptId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tenseConceptId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pronounField", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pronounField"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isPastPerfect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isPastPerfect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "buttonOptionsKey", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "buttonOptionsKey"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "refreshButtonOptions", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "refreshButtonOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pastPerfectOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pastPerfectOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "randomOptionsFromPronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "randomOptionsFromPronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "randomOptionsFromTense", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "randomOptionsFromTense"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctConjugatedVerbString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctConjugatedVerbString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswerFromConjugatedVerbString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswerFromConjugatedVerbString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "frenchPerfectCorrectAnswers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "frenchPerfectCorrectAnswers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputWithoutPronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputWithoutPronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputIsCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputIsCorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputIsCorrectWithoutAccent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputIsCorrectWithoutAccent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputIsMissingWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputIsMissingWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isReflexiveVerb", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isReflexiveVerb"), _class2.prototype), _class2)) || _class;
};
ConjugationCardWrapper.displayName = 'ConjugationCardWrapper';
var _default = exports["default"] = ConjugationCardWrapper;